// extracted by mini-css-extract-plugin
export default {"setting--inverted":"GsvQrZo","dark-theme":"ixKUpPy","radios":"zRi8MvC","paymentTypeExplanation":"Ez6vLTM"};